<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'AlcometerMeasurement' | translate"></app-sub-header>

<div class="padded-container">
    <dx-form>
      <dxi-item>
        <dxo-label text="{{ 'AlcometerValue' | translate }}"></dxo-label>
        <dx-number-box [(value)]="alcoValue" [min]="0" [max]="1000" [step]="0.01" [showSpinButtons]="true" class="full-width-button"></dx-number-box>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
      </dxi-item>
    </dx-form>
  </div>
</div>